import React from "react";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/SuccessStories.css";

import srgImage from "../assests/images/srg.png";
import virtusaImage from "../assests/images/virtusa.png";
import Seo from "../components/Seo";

const SuccessStories = () => {
  return (
    <div className="success-page">
        <Seo path="/success-stories" />
      <Navigation />

      {/* Hero */}
      <section className="success-hero">
        <h1>Client Success Stories</h1>
        <p>Driving Compliance, Automation, and Measurable Business Outcomes</p>
      </section>

      <section className="success-content">
        {/* Virtusa */}
        <div className="story-card">
          <div className="story-header">
            <img src={virtusaImage} alt="Virtusa Consulting" />
            <div>
              <h2>Virtusa Consulting</h2>
              <p className="story-meta">
                <strong>Industry:</strong> IT Consulting & Services <br />
                <strong>Solution Area:</strong> Oracle ERP – GST Compliance &
                ITC Reconciliation
              </p>
            </div>
          </div>

          <div className="story-grid">
            <div>
              <h3>Business Challenges</h3>
              <ul>
                <li>
                  Heavy dependency on manual data entry across business units
                </li>
                <li>
                  Time-consuming corrections impacting finance and procurement
                  teams
                </li>
                <li>High risk of ITC loss due to GST mismatches</li>
                <li>
                  Unstructured Purchase Requisitions causing data inconsistency
                </li>
                <li>Vendor non-compliance leading to delayed payments</li>
                <li>No synchronization between Oracle ERP and GST portal</li>
              </ul>
            </div>

            <div>
              <h3>Outcomes Delivered by Cloudare</h3>
              <ul>
                <li>100% automated PR reconciliation</li>
                <li>80% reduction in manual errors</li>
                <li>Complete prevention of ITC loss</li>
                <li>100% time savings for finance and procurement teams</li>
                <li>Real-time GST validation and reconciliation</li>
                <li>Automated vendor compliance checks</li>
              </ul>
            </div>
          </div>

          <div className="impact-box">
            <strong>Client Impact:</strong>
            <p>
              Cloudare transformed Virtusa’s manual and error-prone workflows
              into a fully automated, compliance-driven system—delivering faster
              operations, reduced financial risk, and measurable efficiency
              gains within just <strong>2 months</strong>.
            </p>
          </div>
        </div>

        {/* SRG */}
        <div className="story-card">
          <div className="story-header">
            <img src={srgImage} alt="Saeed Raddad Group" />
            <div>
              <h2>Saeed Raddad Group (SRG)</h2>
              <p className="story-meta">
                <strong>Industry:</strong> Conglomerate <br />
                <strong>Solution Area:</strong> Oracle ERP – ZATCA E-Invoicing
                Compliance
              </p>
            </div>
          </div>

          <div className="story-grid">
            <div>
              <h3>Business Challenges</h3>
              <ul>
                <li>Non-compliance with ZATCA Phase-2 regulations</li>
                <li>No direct Oracle ERP to ZATCA integration</li>
                <li>Highly complex multi-entity data structures</li>
                <li>Failure to meet PDFA3 invoice standards</li>
                <li>Need for custom invoice classification logic</li>
                <li>Lack of centralized visibility</li>
              </ul>
            </div>

            <div>
              <h3>Outcomes Delivered by Cloudare</h3>
              <ul>
                <li>100% ZATCA Phase-2 compliance achieved</li>
                <li>80% reduction in manual effort</li>
                <li>Zero compliance-related errors</li>
                <li>99% PDFA3 conversion success rate</li>
                <li>40% improvement in financial efficiency</li>
                <li>Centralized real-time compliance dashboard</li>
              </ul>
            </div>
          </div>

          <div className="impact-box">
            <strong>Client Impact:</strong>
            <p>
              Cloudare converted SRG’s complex compliance challenges into a
              scalable, automated, and future-ready solution—ensuring regulatory
              adherence, operational efficiency, and enhanced governance across
              the entire group.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SuccessStories;
